import Axios from 'axios';

const handleCache = () => {
    Axios.get('/meta.json')
        .then(response => response.data)
        .then(meta => {
            const latestVersionDate = meta?.buildDate;
            if (!latestVersionDate) return;
            const cachedDate = localStorage.getItem('buildDate');
            if (!cachedDate) {
                localStorage.setItem('buildDate', latestVersionDate);
                return;
            }
            if (latestVersionDate.toString() !== cachedDate) {
                localStorage.setItem('buildDate', latestVersionDate);
                window.location.reload();
            }
        })
        .catch(() => {});
};

export default handleCache;
